module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "添加校区",
      "modal-append-to-body": false
    },
    on: {
      "close": _vm.close
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "model": _vm.adForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "校区"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请选择校区",
      "filterable": "",
      "multiple": ""
    },
    model: {
      value: (_vm.adForm.unids),
      callback: function($$v) {
        _vm.$set(_vm.adForm, "unids", $$v)
      },
      expression: "adForm.unids"
    }
  }, _vm._l((_vm.campusZoneList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAddCampusZones
    }
  }, [_vm._v("添加")])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "校区"
    }
  }, [_c('div', {
    staticClass: "card-wrap"
  }, _vm._l((_vm.adForm.list), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "dialog-item"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteCampus(item.value)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n            共计" + _vm._s(_vm.adForm.list.length) + "所学校\n         ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubimtForm
    }
  }, [_vm._v("确 定")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c92596e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/AdvertisingSpace/AdManagement/Components/EditCampusDialog.vue
// module id = 1123
// module chunks = 0